<template>
  <div
    class="d-flex justify-space-between align-start"
    :style="!$vuetify.display.mobile ? 'height: 36px' : ''"
  >
    <div class="d-flex flex-row ga-1">
      <show-categories-button />
      <editable-heading
        :value="collection.name"
        :label="$t('collection.editTitle')"
        @input="updateTitle"
      />
      <sf-archived-chip v-if="collection.isArchived" />
    </div>
    <three-point-menu density="comfortable">
      <collection-add-to-cart-button :collection="collection" />
      <collection-request-quote v-if="portalSettings.useQuotes" :collection="collection" />
      <collection-share-button :collection="collection" />
      <v-divider class="my-1" />
      <collection-archive-button :is-archived="collection.isArchived" />
      <collection-duplicate-button :id="collection.id" />
      <collection-delete-button :id="collection.id" />
    </three-point-menu>
  </div>
</template>

<script setup lang="ts">
import SfArchivedChip from '@/components/chips/SfArchivedChip.vue'
import EditableHeading from '@/components/input/EditableHeading.vue'
import ShowCategoriesButton from '@/components/ShowCategoriesButton.vue'
import ThreePointMenu from '@/components/three-point-menu/ThreePointMenu.vue'
import CollectionAddToCartButton from '@/modules/collection/components/CollectionAddToCartButton.vue'
import CollectionArchiveButton from '@/modules/collection/components/CollectionArchiveButton.vue'
import CollectionDeleteButton from '@/modules/collection/components/CollectionDeleteButton.vue'
import CollectionDuplicateButton from '@/modules/collection/components/CollectionDuplicateButton.vue'
import CollectionRequestQuote from '@/modules/collection/components/CollectionRequestQuote.vue'
import CollectionShareButton from '@/modules/collection/components/CollectionShareButton.vue'
import useCollection from '@/modules/collection/useCollection'
import { PortalSettings } from '@/modules/portalSettings/types'
import { DetailedShopCollection } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  collection: {
    type: Object as PropType<DetailedShopCollection>,
    required: true
  },
  portalSettings: {
    type: Object as PropType<PortalSettings>,
    required: true
  }
})

const updateTitle = (title: string) => {
  useCollection().updateName(title)
}
</script>
